import React, { memo } from 'react';
import { CategoryEdit } from '@redlink/components/pages';

export const SelectCategoryPage = memo(
  ({ pageName, type, onDismiss, initialSelectedItem }) => {
    return (
      <CategoryEdit
        selectable
        style={{ padding: 0, borderRadius: 0 }}
        {...{ pageName, type, onDismiss, initialSelectedItem }}
      />
    );
  }
);
